export default __webpack_public_path__ + "static/media/9.4f17a57a.svg";